import { type TStatus } from '../../types/context';

export const AVAILABLE_STATUS_LIST: TStatus[] = ['loading', 'failed'];

export const TITLE_MAPPING: { [key in TStatus]?: string } = {
  failed: 'Что-то пошло не так',
};
